import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik-2';
import { ParameterDisplayTypes } from '../../types';
import { TextField, Checkbox } from '../../../../components/widgets';
import { DropdownFieldEnhanced } from '../../../../utils/components/formUtils';
import css from './PartnerParameters.css';

function ParametersFactory({ parameters, isReadonly = false }) {
    const { values, touched, errors, setFieldValue, setFieldTouched } = useFormikContext();

    useEffect(() => {
        parameters.forEach(param => {
            if (!Object.keys(values).includes(param.name)) {
                setFieldValue(param.name, '');
            }

            if (
                param.displayType === ParameterDisplayTypes.CHECKBOX &&
                (!Object.keys(values).includes(param.name) || values[param.name] === '')
            ) {
                setFieldValue(param.name, param.predefinedValues?.[0] === 'True' ? 'True' : 'False');
            }
        });
    }, [parameters]);

    const onTextFieldChange = (name, value) => {
        setFieldValue(name, value);
    };

    const onTextFieldBlur = name => {
        setFieldTouched(name, true);
    };

    return parameters.map(({ name, description, label, predefinedValues, displayType }) => {
        const props = {
            name,
            label,
            labelTooltip: description,
            error: touched[name] && errors[name],
            disabled: isReadonly,
        };

        let field;
        switch (displayType) {
            case ParameterDisplayTypes.DROPDOWN:
                field = (
                    <DropdownFieldEnhanced
                        {...props}
                        placeholder="STATIC.SELECT"
                        containerClass={css.parameterField}
                        items={predefinedValues?.map(value => ({ name: value, display_name: value }))}
                        selected={values[name]}
                    />
                );
                break;
            case ParameterDisplayTypes.CHECKBOX:
                field = (
                    <Checkbox
                        {...props}
                        checked={values[name] === 'True'}
                        onChange={checked => setFieldValue(name, checked ? 'True' : 'False')}
                        labelClass={css.checkboxLabelClass}
                    />
                );
                break;
            default:
                field = (
                    <TextField
                        {...props}
                        placeholder="STATIC.TYPE_IN"
                        containerClass={css.parameterField}
                        value={values[name]}
                        onChange={value => onTextFieldChange(name, value)}
                        onBlur={() => onTextFieldBlur(name)}
                    />
                );
        }

        return (
            <div key={name} style={{ display: 'contents' }} data-field-error={props.error ? name : undefined}>
                {field}
            </div>
        );
    });
}

ParametersFactory.propTypes = {
    parameters: PropTypes.array.isRequired,
    isReadonly: PropTypes.bool,
};

export default ParametersFactory;
